import {
	createStore,
	createStateHook,
	createActionsHook,
	type BoundActions,
	type HookActionsFunction,
	type HookStateFunction,
	type StoreActionApi,
} from 'react-sweet-state';

type SidePanelState = {
	isSidePanelOpen: boolean;
};
export const initialSidePanelState = {
	isSidePanelOpen: false,
};

export const actions = {
	showSidePanel:
		() =>
		({ setState }: StoreActionApi<SidePanelState>): void => {
			setState({ isSidePanelOpen: true });
		},
	hideSidePanel:
		() =>
		({ setState }: StoreActionApi<SidePanelState>): void => {
			setState({ isSidePanelOpen: false });
		},
};
type SidePanelActionType = typeof actions;

const Store = createStore<SidePanelState, SidePanelActionType>({
	initialState: initialSidePanelState,
	actions,
	name: 'SidePanelState',
});

export const useSidePanelStateActions: HookActionsFunction<
	BoundActions<
		SidePanelState,
		{
			showSidePanel: () => ({ setState }: StoreActionApi<SidePanelState>) => void;
			hideSidePanel: () => ({ setState }: StoreActionApi<SidePanelState>) => void;
		}
	>
> = createActionsHook(Store);

export const useIsSidePanelOpen: HookStateFunction<boolean, void> = createStateHook(Store, {
	selector: (state: SidePanelState) => state.isSidePanelOpen,
});
